export const ArrowRight = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M13.4037 7.5L16.9358 11.2045C17.3547 11.6438 17.3547 12.3562 16.9358 12.7955L13.4037 16.5M16.6217 12H6.75"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};
